<script setup lang="ts">
import { legalCompany as c } from '~/content/legal'
</script>

<template>
    <LegalPage title="Conditions générales d’utilisation"
        description="Conditions générales d’utilisation du site Deboosere Chauffage Sanitaire.">
        <h2>1. Objet</h2>
        <p>
            Les présentes conditions générales d’utilisation (CGU) définissent les modalités d’accès et d’utilisation
            du site édité par {{ c.name }} (ci-après « le Site »). Toute navigation sur le Site vaut acceptation
            sans réserve des présentes CGU.
        </p>

        <h2>2. Accès au Site</h2>
        <p>
            Le Site est accessible gratuitement à tout utilisateur disposant d’un accès à internet. Les frais liés à
            cet accès (matériel, connexion) restent à la charge de l’utilisateur.
        </p>
        <p>
            L’éditeur s’efforce d’assurer un accès continu au Site mais ne peut le garantir. L’accès peut être
            interrompu, notamment pour maintenance ou en cas de force majeure, sans que cela ouvre droit à
            indemnisation.
        </p>

        <h2>3. Services proposés</h2>
        <p>
            Le Site présente les prestations de plomberie, chauffage, climatisation et sanitaire de l’entreprise, à
            destination des particuliers et des professionnels, et permet de la contacter par téléphone ou via un
            formulaire de demande d’intervention ou de devis.
        </p>
        <p>
            Les informations publiées sont fournies à titre indicatif. Elles ne constituent pas une offre
            contractuelle : seul le devis accepté engage les parties, dans les conditions prévues par nos
            <NuxtLink to="/cgv">conditions générales de vente</NuxtLink>.
        </p>

        <h2>4. Utilisation du formulaire de contact</h2>
        <p>L’utilisateur s’engage à :</p>
        <ul>
            <li>fournir des informations exactes et le concernant ;</li>
            <li>ne pas utiliser le formulaire à des fins de prospection, de spam ou de manière frauduleuse ;</li>
            <li>ne transmettre aucun contenu illicite, injurieux ou portant atteinte aux droits de tiers.</li>
        </ul>
        <p>
            L’envoi d’une demande n’engage ni l’utilisateur ni l’entreprise ; il permet simplement d’être recontacté.
        </p>

        <h2>5. Propriété intellectuelle</h2>
        <p>
            Les contenus du Site sont protégés par le droit de la propriété intellectuelle. Les conditions sont
            détaillées dans nos <NuxtLink to="/mentions-legales">mentions légales</NuxtLink>.
        </p>

        <h2>6. Responsabilité</h2>
        <p>
            L’éditeur met tout en œuvre pour offrir des informations fiables et à jour, sans pouvoir garantir
            l’absence d’erreur ou d’omission. Il ne saurait être tenu responsable des dommages directs ou indirects
            résultant de l’utilisation du Site, d’une interruption de service ou de la présence de virus.
        </p>
        <p>
            Les conseils publiés ne remplacent pas le diagnostic d’un professionnel sur place. En cas d’odeur de
            gaz, coupez l’arrivée de gaz, aérez, quittez les lieux et contactez le numéro d’urgence de votre
            distributeur de gaz ou les pompiers (18 ou 112).
        </p>

        <h2>7. Liens hypertextes</h2>
        <p>
            Le Site peut contenir des liens vers des sites tiers (Facebook, avis Google…). L’éditeur n’exerce aucun
            contrôle sur ces sites et décline toute responsabilité quant à leur contenu.
        </p>

        <h2>8. Avis clients</h2>
        <p>
            Les avis affichés sont issus de la fiche Google de l’entreprise et sont publiés par leurs auteurs sur
            cette plateforme. Ils ne font l’objet d’aucune contrepartie. Seuls les avis notés 5 étoiles sont
            sélectionnés pour être affichés sur le Site ; l’ensemble des avis, y compris les moins favorables, reste
            consultable sur la fiche Google de l’entreprise.
        </p>

        <h2>9. Données personnelles</h2>
        <p>
            Le traitement des données personnelles est décrit dans notre
            <NuxtLink to="/politique-de-confidentialite">politique de confidentialité</NuxtLink> et dans notre
            <NuxtLink to="/cookies">politique de cookies</NuxtLink>.
        </p>

        <h2>10. Modification des CGU</h2>
        <p>
            L’éditeur peut modifier les présentes CGU à tout moment. La version applicable est celle en ligne au
            moment de la navigation.
        </p>

        <h2>11. Droit applicable</h2>
        <p>
            Les présentes CGU sont soumises au droit français. En cas de litige, et à défaut de résolution amiable,
            les tribunaux français sont compétents.
        </p>
    </LegalPage>
</template>
